<template>
  <div
    class="has-background-transparent"
    style="border: 0 !important">
    <div class="columns is-gapless has-background-light is-marginless is-vcentered is-border-right is-border-left is-minH50p">
      <div class="column is-padding-left is-padding-right">
        <span v-if="sortedHistory && sortedHistory.length && sortedHistory[0].date">
          Votre dernière intéraction avec le contact
          <b>{{ sortedHistory[0].date | prettyDate }}</b>
          à {{ sortedHistory[0].date | prettyTime }}
        </span>
        <span v-else>
          Votre dernière intéraction avec le contact : <b>Aucune</b>
        </span>
      </div>
    </div>
    <div class="">
      <div class="columns is-multiline is-variable is-2">
        <div class="column">
          <div v-if="sortedHistory && sortedHistory.length">
            <div
              v-for="(h, i) in sortedHistory"
              :key="h.pk"
              class="columns is-gapless is-multiline is-marginless is-border-bottom is-border-right is-border-left"
              :class="{'has-background-light': i % 2, 'has-background-white': !(i % 2), 'is-border-top': (i == 0)}">
              <div class="column is-narrow is-padding has-vertical-separator">
                <div class="is-margin-top-xsmall">
                  <span
                    class="vadPicto is-medium"
                    :class="h.color">
                    <span class="has-text-white"><i :class="h.icon" /></span>
                  </span>
                </div>
              </div>
              <div class="column is-padding-top is-padding-left ">
                <div class="is-padding-right is-margin-bottom-small">
                  <!-- Date d'ajout dans l'Historique -->
                  <div class="has-text-grey is-size-6">
                    Le : {{ h.date | date }} à {{ h.date | prettyTime }}
                  </div>
                  <div>
                    <!-- TITRE DU TYPE  -->
                    <b
                      v-if="h.type === 'RDV'"
                      class="is-uppercase">{{ h.rdvType }} avec {{ h.userName }} le
                      <router-link
                        v-if="currentUser.account.pk === h.userAccount"
                        :to="{name: 'CalendarDay', params: { year: h.year, month: h.month, day: h.day, panel: 'rdvs' }}">
                        <a class="is-underline">{{ h.moment }}</a>
                      </router-link>
                      <span v-else>{{ h.moment }}</span>
                    </b>
                    <b
                      v-else
                      class="is-uppercase">{{ h.typeName }}</b>
                    <!-- INFORMATION HISTORY -->
                    <b
                      v-if="h.type === 'HISTORY'"
                      class="is-uppercase">{{ h.info }}</b>
                    <!-- TEMPLATE SHARE_INTENT -->
                    <template v-if="h.type === 'SHARE_INTENT'">
                      <span v-if="'from' in h && h.from && h.from_pk !== currentUser.account.pk"><span class="has-text-grey"> - Par : </span>
                        <router-link
                          v-if="accounts.find(a=>a.name===h.from.name) && accounts.find(a=>a.name===h.from.name).promoteur_details_activated"
                          class="is-linkTextPicto"
                          :to="{name: 'PromoteurPresentation', params: {id: h.from.pk}}">
                          <span class="">{{ h.from.name }}</span>
                        </router-link>
                        <b v-else>{{ h.from.name }}</b>
                      </span>
                      <span v-if="'to' in h && h.to && h.from_pk === currentUser.account.pk"><span class="has-text-grey"> - Pour : </span><b>{{ h.to.name }}</b></span>
                      <div class="has-text-grey is-size-6">
                        <span v-if="h.status">statut : {{ h.status }} le {{ h.updated_on | date }}</span>
                      </div>
                    </template>
                    <!-- ADF REF POUR TOUS-->
                    <span v-if="h.advRef"> - </span>
                    <router-link
                      v-if="h.advRef"
                      :to="{name: 'AdvInfos', params: {id: h.advPk}}"
                      class="has-text-grey is-underline is-size-5">
                      <span>Ref ADV : <b>{{ h.advRef }}</b></span>
                    </router-link>
                  </div>
                  <!-- INFORMATION LOT POUR TOUS -->
                  <div
                    class="has-text-grey is-size-6">
                    <span v-if="h.lotName">Lot :
                      <router-link
                        :to="{name: 'LotVue', params: {id: h.lot}}"
                        class="is-uppercase"><b>{{ h.lotName }}</b></router-link>
                    </span>
                    <span v-if="h.lotName && h.programName"> - </span>
                    <span v-if="h.programName">Programme :
                      <router-link
                        :to="{name: 'ProgramVue', params: {id: h.program}}"
                        class="is-uppercase"><b>{{ h.programName }}</b></router-link>
                    </span>
                  </div>
                  <div>
                    <!-- INFORMATION VENDEUR POUR TOUS -->
                    <div class="is-flex-nowrap">
                      <span
                        v-if="h.userName"
                        class="has-text-grey"> Vendeur : </span>
                      <router-link
                        class="router-link-item"
                        v-if="h.userName"
                        :to="{name: 'UserVue', params: {id: h.user}}">
                        <b class="is-uppercase"> {{ h.userName }}</b>
                      </router-link>
                    </div>
                    <!-- INFORMATION SOCIETE POUR TOUS -->
                    <div class="is-flex-nowrap">
                      <span
                        v-if="h.account"
                        class="has-text-grey"> Société : </span>
                      <router-link
                        class="router-link-item"
                        v-if="h.account !== currentUser.account.pk && h.accountName"
                        :to="{name: 'CompanyVue', params: {id: h.account}}">
                        <b class="is-uppercase">{{ h.accountName }}</b>
                      </router-link>
                      <b
                        v-else-if="h.accountName"
                        class="is-uppercase">{{ h.accountName }}</b>
                    </div>
                  </div>
                  <div>
                    <p v-if="h.status === 'canceled' || h.status === 'deferred'">
                      Le rendez-vous est <b>{{ rdvStatus[h.status].label }}.</b>
                    </p>
                    <p v-else-if="h.status === 'successful' && h.result">
                      Bilan : <b>{{ reportBlock[h.result].bilan.info }}</b>
                    </p>
                    <router-link
                      v-else-if="h.type === 'RDV' && currentUser.account.pk === h.userAccount"
                      class="has-text-danger is-italic is-underline is-size-6"
                      :to="{name: 'CalendarDay', params: { year: h.year, month: h.month, day: h.day, panel: 'rdvs' }}">
                      Bilan RDV en attente
                    </router-link>
                  </div>
                  <div
                    v-if="h.comment && h.type !== 'OPTION'"
                    class="columns is-gapless is-padding-less has-text-grey is-size-5 is-marginless-bottom">
                    <p class="column is-narrow">
                      Commentaire :
                    </p>
                    <p
                      class="column is-padding-left-xsmall"
                      v-html="h.comment" />
                  </div>
                  <div
                    v-if="h.type === 'SALE_SUBSTITUTED'"
                    class="is-flex">
                    <span class="has-text-grey is-size-6 is-padding-right-xxsmall">
                      Substitué par :
                      <router-link
                        v-for="(b, idx) in h.substitutedBy"
                        :key="b.pk"
                        :to="{name: 'ContactVue', params: {id: b.pk}}"
                        class="is-underline"
                        style="font-weight: bold; color: #24323b">{{ b.name }}<template v-if="idx < h.substitutedBy.length - 1">, </template></router-link>
                    </span>
                  </div>
                  <div
                    v-if="h.replaces"
                    class="is-flex">
                    <span class="has-text-grey is-size-6 is-padding-right-xxsmall">
                      Substituant de :
                      <router-link
                        v-for="(b, idx) in h.replaces"
                        :key="b.pk"
                        :to="{name: 'ContactVue', params: {id: b.pk}}"
                        class="is-underline"
                        style="font-weight: bold; color: #24323b">{{ b.name }}<template v-if="idx < h.replaces.length - 1">, </template></router-link>
                      <template v-if="h.createdDate"> - Réservation créée le <span style="font-weight: bold; color: #24323b">{{ h.createdDate | date }} à {{ h.createdDate | prettyTime }}</span></template>
                    </span>
                  </div>
                  <div
                    v-if="h.type === 'SALE_CANCELED'"
                    class="is-flex">
                    <span
                      class="has-text-grey is-size-6 is-padding-right-xxsmall">
                      Motif d'annulation : <span style="font-weight: bold; color: #24323b">{{ getCancelReasonLabel(h.canceledReason) }}</span>
                    </span>
                    <span
                      class="has-text-grey is-size-6 is-padding-right-xxsmall">
                      - Date : <span style="font-weight: bold; color: #24323b">{{ h.dateCancel | date }} à {{ h.dateCancel | prettyTime }}</span>
                    </span>
                  </div>
                  <div
                    class="is-flex is-padding-bottom-small"
                    v-if="h.type === 'OPTION'">
                    <span class="has-text-grey is-size-6 is-padding-right-xxsmall">
                      Date de signature envisagéé :
                    </span>
                    <span class="is-size-6">
                      <b>
                        <date-picker
                          :text="'NC'"
                          :id="`datepicker${h.pk}`"
                          :from-option="true"
                          :model="h.previous_sign_date"
                          :style-version="4"
                          :clearable="false"
                          :not-init-date="true"
                          @input="updatePreviousDate($event, h); onChangeModifDate(h)"></date-picker>
                      </b>
                    </span>
                  </div>
                  <a
                    v-if="h.type === 'OPTION' && isPromoteur && !h.comment && !showCom[h.pk]"
                    @click="toggleCom(h.pk); openWysiwyg(i, h)"
                    style="font-size: 12px"
                    class="is-underline is-italic">Ajouter commentaire
                  </a>
                </div>
                <div
                  class="is-padding-xsmall"
                  style="background-color : #FAFAFA"
                  v-if="h.type === 'OPTION' && isPromoteur && (showCom[h.pk] || h.comment)">
                  <div class="row-width-actions-bar columns is-gapless is-marginless">
                    <div class="column is-self-centered is-padding-top-xxsmall is-padding-bottom-xxsmall has-background-white-bis">
                      <span class="title is-6">
                        <span class="is-uppercase is-margin-right-xsmall">{{ 'Commentaire :' }}</span>
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="openCommentWysi === i"
                    class="is-border-top columns is-gapless has-background-white">
                    <div class="column">
                      <wysiwyg-editor
                        :light="true"
                        :tooltip-top="true"
                        :model="h.comment"
                        @change="onChangeCom(h, $event)"
                        class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
                      </wysiwyg-editor>
                    </div>
                    <div class="actionsOnRow actionsOnRow--vertical">
                      <div>
                        <button
                          @click="onChangeModifDate(h); patchComment(h, i); lastIndex = null; lastCommentInit = null; baseLotComment = null; openCommentWysi = null"
                          type="button"
                          class="button"
                          :class="[(baseLotComment !== h.comment) ? 'is-success' : 'is-info']"
                          :disabled="!h.comment || (baseLotComment === h.comment) || loadOptionComment">
                          <span class="icon is-small">
                            <i
                              v-if="loadOptionComment"
                              class="fas fa-spinner fa-spin"></i>
                            <i
                              v-else
                              class="fal fa-save"></i>
                          </span>
                        </button>
                      </div>
                      <div class="">
                        <button
                          type="button"
                          :class="'actionsOnRow-btn--hoverIsDanger'"
                          @click="saveCom(h); lastIndex = null; lastCommentInit = null; openCommentWysi = null; h.comment = baseLotComment; baseLotComment = null; openWysiOption = null">
                          <span class="icon is-small"><i class="fal fa-times"></i></span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    v-else
                    @click="openWysiwyg(i, h)"
                    class="vadDiscussion is-border-top"
                    style="cursor: pointer;">
                    <div
                      class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
                      <div
                        class="content"
                        v-html="h.comment"></div>
                    </div>
                  </div>
                  <div class="is-flex-between is-margin-top-xxsmall has-background-white-bis">
                    <div>
                      <span
                        v-if="h.updated_on !== null"
                        class="is-size-6 has-text-weight-semibold is-margin-right-small">Date mise à jour option :
                        <span class="has-text-weight-normal">{{ h.updated_on | prettyDatetime }}</span></span>
                    </div>
                    <div class="is-flex is-wrap-flex">
                      <span
                        @click="openWysiwyg(i, h)"
                        v-if="isPromoteur && openWysiOption === null"
                        class="is-size-6 is-underline is-margin-right-small has-cursor-pointer is-padding-right-xxsmall"><i>Modifier</i></span>
                      <span
                        @click="deleteComment(h, i); lastIndex = null; lastCommentInit = null;"
                        v-if="isPromoteur && openWysiOption === null"
                        class="is-size-6 is-underline has-cursor-pointer"><i>Supprimer</i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="has-background-light is-padding">
            <i>Pas d'historique pour le contact</i>
          </div>
        </div>
        <div class="column is-6 is-5-fullhd">
          <div class="is-padding-right is-padding-top-xxsmall has-background-white is-border-top is-border-right is-border-left columns is-gapless is-vcentered is-marginless-bottom">
            <div
              @click="isNoteSuivi = true"
              :style="isNoteSuivi ? 'border-bottom: 3px solid black' : 'padding-bottom: 2.8px'"
              style="min-width: 130px; cursor: pointer; justify-content: center; align-items: center; position: relative"
              class="is-flex is-nowrap has-text-centered">
              <div
                style="padding: 10.5px"
                class="title is-6 has-text-weight-normal is-uppercase">
                Note(s) de suivi ({{ contactNotesFilter.length }})
              </div>
            </div>
            <div
              @click="isNoteSuivi = false"
              :style="!isNoteSuivi ? 'border-bottom: 3px solid black;' : 'padding-bottom: 3px'"
              style="justify-content: center; align-items: center; cursor: pointer"
              class="is-flex has-text-centered">
              <div
                class="title is-6 has-text-weight-normal is-uppercase is-padding-right-xsmall is-padding-left is-padding-top-xxsmall is-padding-bottom-xxsmall"
                style="height: 100%; margin-bottom: 0; border-left: 1px solid #808080">
                Rappel ({{ reminderForContact.length }})
              </div>
              <div
                class="is-flex-center is-padding-xsmall"
                style="height: 100%"
                :style="true ? 'background-color: white' : 'background-color:red'">
                <i
                  v-if="true"
                  class="fal fa-alarm-clock"
                  style="color: black">
                </i>
                <i
                  v-else
                  class="fal fa-alarm-exclamation"
                  style="color: white"></i>
              </div>
            </div>
          </div>
          <div v-if="isNoteSuivi">
            <button
              type="submit"
              style="justify-content: flex-start; border-radius: 0px; border-color: #ebebeb"
              class="button is-secondary is-xsmall is-fullwidth is-padding-left-small is-padding-top is-padding-bottom"
              :disabled="openWysi !== null"
              @click="openWysi = 'new'">
              <span
                style="font-size: 12px"
                class="is-uppercase">Nouvelle note de suivi</span>
            </button>
          </div>
          <!-- RAPPEL ONGLET -->
          <div v-else>
            <button
              type="submit"
              style="justify-content: flex-start; border-radius: 0px; border-color: #ebebeb;"
              class="button is-secondary is-xsmall is-fullwidth is-padding-left-small is-padding-top is-padding-bottom"
              @click="openReminderCreation()">
              <span
                style="font-size: 12px"
                class="is-uppercase">Créer Rappel</span>
            </button>
          </div>
          <!-- RAPPEL -->
          <div
            class="is-flex"
            v-if="!isNoteSuivi"
            style="height: 100%; min-height: 100%; width: 100%; flex-direction: column">
            <div
              v-for="remind in reminderForContact"
              :key="remind.pk"
              class="is-flex"
              style="width: 100%">
              <!-- HORLOGE -->
              <div
                class="is-flex-center is-border is-padding-left-small is-padding-right-small is-padding-top is-padding-bottom"
                style=""
                :style="isRemindInFuture(remind.date) ? 'background-color: white' : 'background-color:red'">
                <i
                  v-if="isRemindInFuture(remind.date)"
                  class="fal fa-alarm-clock"
                  style="color: black">
                </i>
                <i
                  v-else
                  class="fal fa-alarm-exclamation"
                  style="color: white"></i>
              </div>
              <!-- ELEMS -->
              <div
                style="flex-direction: column; width: 100%"
                class="is-flex">
                <div
                  style="background-color: #FCFCFC; justify-content: space-between; min-height: 80px"
                  class="is-fullwidth is-border-top is-border-bottom is-border-right is-flex is-nowrap">
                  <div
                    style="justify-content: center; flex-direction: column; flex-shrink: 2"
                    class="is-padding-left-small is-flex is-size-6">
                    <span class="is-flex is-wrap-flex">De:
                      &nbsp;
                      <b>{{ remind.author.pk === currentUser.pk ? 'Vous' : `${remind.author.first_name} ${remind.author.last_name}` }}</b>&nbsp;/ Pour:&nbsp;
                      <b>
                        {{ remind.user.pk === currentUser.pk ? 'Vous' : `${remind.user.first_name} ${remind.user.last_name}` }}
                      </b>
                    </span>
                    <span class="is-flex is-wrap-flex">Echéance :&nbsp;<b>{{ remind.date | prettyDate }} à {{ remind.date | prettyTime }}</b></span>
                  </div>
                  <div
                    class="is-flex"
                    style="background-color: white; flex-shrink: 0">
                    <div
                      @click="updateReminder(remind)"
                      style="min-width: 40px; cursor: pointer"
                      class="update-hover is-flex-center is-border-left is-border-right is-padding-left-small is-padding-right-small is-padding-top-xxsmall is-padding-bottom-xxsmall">
                      <i class="far fa-pen"></i>
                    </div>
                    <!-- <div
                      style="min-width: 40px; cursor: pointer"
                      class="is-flex-center is-border is-padding-left-small is-padding-right-small is-padding-top-xxsmall is-padding-bottom-xxsmall">
                      <i class="far fa-check"></i>
                    </div> -->
                    <div
                      @click="deleteReminder(remind)"
                      style="min-width: 40px; cursor: pointer"
                      class="delete-hover is-flex-center is-padding-left-small is-padding-right-small is-padding-top-xxsmall is-padding-bottom-xxsmall">
                      <i class="far fa-trash"></i>
                    </div>
                  </div>
                </div>
                <div
                  style="background-color: #FFFFFF; min-height: 80px"
                  class="is-fullwidth is-border-bottom is-border-right is-flex is-padding-top-small is-padding-bottom-small is-padding-right-xxsmall">
                  <div
                    style="justify-content: center"
                    class="is-padding-left-small is-flex is-column is-size-6">
                    <div class="is-flex">
                      <div class="has-text-weight-bold">
                        Objet:&nbsp;
                      </div>
                      {{ remind.title }}
                    </div>
                    <div class="is-flex">
                      <!-- <span style="width: 100%; height: auto">Détails:&nbsp;</span>
                      <div v-html="remind.note"></div> -->
                      <div v-html="`<b>Détails :</b> ${remind.note || ''}`"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Note de suivi  -->
          <div
            v-else-if="openWysi == 'new' && isNoteSuivi"
            class="is-border has-background-white">
            <contact-note
              :source="{message: ''}"
              @deleteNote="deleteNote"
              @close="noteClose"
              @save="noteSave" />
          </div>
          <div
            v-if="contactNotesFilter && contactNotesFilter.length && isNoteSuivi"
            class="has-background-white is-padding is-border-left is-border-right">
            <div
              v-for="(note) in contactNotesFilter"
              :key="note.pk"
              class="vadDiscussion">
              <div
                v-if="note.pk !== openWysi"
                class="vadDiscussion--bulle is-size-6"
                :class="{'is-classic': note.user && note.user.pk != currentUser.pk}">
                <div
                  class="content is-break-word"
                  v-html="note.message" />
              </div>
              <contact-note
                v-else
                :source="note"
                class="is-border"
                @deleteNote="deleteNote"
                @close="noteClose"
                @save="noteSave" />
              <div class="level">
                <div class="level-left">
                  <div class="is-size-7">
                    <div><b>Date : </b>{{ note.created_on | prettyDate }}</div><!-- prettyDate -->
                    <div v-if="note.user">
                      <b>Auteur : </b>{{ note.user.last_name }} {{ note.user.first_name }}
                    </div>
                  </div>
                </div>
                <div class="level-right">
                  <button
                    v-if="note.user && note.user.pk == currentUser.pk"
                    type="submit"
                    class="button is-white is-border is-rounded is-xsmall"
                    :disabled="openWysi !== null"
                    @click="openWysi = note.pk">
                    <span class="icon is-small"><i class="fas fa-marker" /></span>
                    <span>Modifier note</span>
                  </button><!-- @click="openNoteQuickview({ item: Object.assign({}, note) })" -->
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="!contactNotesFilter.length && openWysi === null && isNoteSuivi"
            class="has-background-white is-padding-right is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall is-border-left is-border-top is-border-right">
            <span class="is-size-6"><i>Aucune note de suivi</i></span>
          </div>
          <div
            v-if="contactNotes.length > notesCompactMode && isNoteSuivi"
            class="is-border">
            <button
              class="button is-light is-small is-fullwidth is-padding-left"
              @click="toggleNotes()">
              <div
                v-if="contactNotesFilter.length < contactNotes.length"
                class="w100 has-text-left">
                <span class="icon"><i class="far fa-chevron-down" /></span>
                <span>{{ contactNotes.length - contactNotesFilter.length }} notes supplémentaires</span>
              </div>
              <div
                v-else
                class="w100 has-text-left">
                <span class="icon"><i class="far fa-chevron-up" /></span>
                <span>Masquer notes anciennes</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactMixin from '../ContactMixin'
import Quickview from '@/mixins/QuickviewMixin'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'
Vue.prototype.moment = moment

const HISTORY_REPORT_BLOCK = {
  not_interested: {
    bilan: {
      info: 'Pas intéréssé'
    },
    report: null
  },
  new_rdv: {
    bilan: {
      info: 'Intéréssé'
    },
    report: {
      info: 'Planifier nouveau rendez-vous',
      is_link: true
    }
  },
  to_be_continued: {
    bilan: {
      info: 'Intéréssé'
    },
    report: {
      info: 'À suivre',
      is_link: false
    }
  },
  plan_visit: {
    bilan: {
      info: 'Intéréssé'
    },
    report: {
      info: 'Planifier rendez-vous visite',
      is_link: true
    }
  },
  sign: {
    bilan: {
      info: 'Intéréssé'
    },
    report: {
      info: 'Planifier rendez-vous signature',
      is_link: true
    }
  },
  taxation: {
    bilan: {
      info: 'Hors cible'
    },
    report: {
      info: 'Imposition',
      is_link: false
    }
  },
  age: {
    bilan: {
      info: 'Hors cible'
    },
    report: {
      info: 'Âge',
      is_link: false
    }
  },
  period: {
    bilan: {
      info: 'Hors cible'
    },
    report: {
      info: 'Période',
      is_link: false
    }
  },
  funding: {
    bilan: {
      info: 'Hors cible'
    },
    report: {
      info: 'Financement',
      is_link: false
    }
  },
  no_offer: {
    bilan: {
      info: 'Contact Hors cible'
    },
    report: {
      info: 'Pas d\'offre',
      is_link: false
    }
  },
  other: {
    bilan: {
      info: 'Contact Hors cible'
    },
    report: {
      info: 'Autre',
      is_link: false
    }
  }
}

export default {
  name: 'ContactHistory',
  components: {
    ContactNote: () => import('./ContactNote'),
    DatePicker: () => import('@/components/utils/form/DatePicker.vue')
  },
  mixins: [Quickview, ContactMixin],
  data () {
    return {
      reportBlock: HISTORY_REPORT_BLOCK,
      viewAllNotes: false,
      notesCompactMode: 3, // Nombre de notes affichées en compact mode
      openWysi: null, // PK du commentaire à ouvrir ou 'new' pour un nouveau commentaire
      baseLotComment: null,
      openWysiOption: null,
      lastDate: null,
      lastPk: null,
      dataCom: null,
      showCom: {},
      lastIndex: null,
      lastCommentInit: null,
      isNoteSuivi: true,
      reminderForContact: []
    }
  },
  computed: {
    ...mapGetters(['accounts']),
    ...mapState([]),
    history () {
      if (this.contact.history && this.contact.history.length) {
        let history = this.contact.history.slice().find(x => ['CONTACT_CREATED', 'NEW'].includes(x.flag))
        if (history) {
          return [{
            // date: moment(history.created_on.seconds * 1000).toDate(),
            date: moment(history.created_on.seconds * 1000).utc().format('YYYY-MM-DDTHH:mm:ss'), // pour garder le format utc lors du sortedHistory
            type: 'HISTORY',
            flag: history.flag,
            info: history.title,
            typeName: null,
            color: 'has-background-dark',
            icon: 'fal fa-users-cog'
          }]
        }
      }
      return []
    },
    updateUserHistory () {
      if (this.contact.history && this.contact.history.length) {
        let history = this.contact.history.slice().find(x => ['CONTACT_USER_UPDATED'].includes(x.flag))
        if (history) {
          return [{
            date: moment(history.created_on.seconds * 1000).utc().format('YYYY-MM-DDTHH:mm:ss'), // pour garder le format utc lors du sortedHistory
            type: 'HISTORY',
            flag: history.flag,
            info: history.title,
            typeName: null,
            color: 'has-background-dark',
            icon: 'fal fa-users-cog'
          }]
        }
      }
      return []
    },
    shareIntent () {
      if (this.contact.history && this.contact.history.length) {
        let intent = this.contact.history.slice().find(x => ['SHARE_INTENT'].includes(x.flag))
        if (intent) {
          const statusName = {
            'pending': 'En attente',
            'refused': 'Refusé',
            'approved': 'Accepté',
            'terminated': 'Annulé',
            'partially_approved': 'En demande d\'acceptation'
          }
          let status = statusName[intent.status]
          return [{
            // date: moment(intent.created_on.seconds * 1000).toDate(),
            date: moment(intent.created_on.seconds * 1000).utc().format('YYYY-MM-DDTHH:mm:ss'),
            type: 'SHARE_INTENT',
            flag: intent.flag,
            updated_on: intent.updated_on,
            status,
            info: intent.title,
            from_pk: intent.from.pk,
            from: intent.from,
            to: intent.to,
            typeName: 'Contact partagé',
            color: 'has-background-dark',
            icon: 'fal fa-people-arrows'
          }]
        }
      }
      return []
    },
    options () {
      return this.contactOptions.map(x => {
        return {
          date: x.created_on,
          type: 'OPTION',
          typeName: 'Option',
          color: 'has-background-optioned',
          icon: 'fal fa-flag',
          user: x.user.pk,
          userName: `${x.user.last_name} ${x.user.first_name}`,
          account: x.account.pk,
          accountName: x.account.name,
          lot: x.lot.pk,
          lotName: x.lot.ref,
          program: x.program.pk,
          programName: x.program.name,
          hasBadge: false,
          comment: x.comment,
          pk: x.pk,
          updated_on: x.updated_on,
          previous_sign_date: x.previous_sign_date
        }
      })
    },
    claims () {
      return this.contactClaims.filter(x => x.status === 'approved').map(x => {
        return {
          date: x.created_on,
          type: 'DENONCIATION',
          typeName: 'Dénonciation',
          color: 'has-background-optioned',
          icon: 'fal fa-flag',
          user: x.user.pk,
          userName: `${x.user.last_name} ${x.user.first_name}`,
          program: x.program.pk,
          programName: x.program.name
        }
      })
    },
    rdvs () {
      if (this.canUseCalendar) {
        return this.sourceContactRdvs.map(x => {
          return {
            date: x.created_on,
            year: moment(x.date).format('YYYY'),
            month: moment(x.date).format('MM'),
            day: moment(x.date).format('DD'),
            type: 'RDV',
            rdvType: x.rdv_type,
            dateInit: x.date,
            moment: moment(x.date).format('DD/MM/YYYY'),
            user: x.user.pk,
            userName: `${x.user.last_name} ${x.user.first_name}`,
            userAccount: x.user.account.pk,
            typeName: `${x.rdv_type} avec ${x.user.last_name} ${x.user.first_name} le ${moment(x.date).format('DD/MM/YYYY')}`,
            color: 'has-background-rdv',
            icon: 'far fa-calendar-alt',
            comment: x.note,
            hasBadge: true,
            badgeStatus: '',
            status: x.status,
            result: x.result,
            contactName: `${x.contact.last_name} ${x.contact.first_name}`,
            baseOptionComment: null,
            openCommentWysi: null,
            openWysi: null
          }
        })
      } else {
        return []
      }
    },
    reservations () {
      return this.contactReservations.map(x => {
        let type = 'SALE'
        let typeName = 'Vente actée'
        let color = 'has-background-sold'
        let icon = 'fas fa-award'
        let date = x.sale_date
        let canceledReason = null
        let dateCancel = null
        if (x.status === 'reserved') {
          type = 'SALE_RESERVATION'
          typeName = 'Réservation'
          color = 'has-background-reserved'
          icon = 'fas fa-file-certificate'
          date = x.signature_date
        }
        if (x.status.includes('canceled')) {
          type = 'SALE_CANCELED'
          typeName = 'Réservation annulée'
          color = 'has-background-draft'
          date = x.created_on
          icon = 'fas fa-file-certificate'
          canceledReason = x.canceled_reason.canceled_choice_type
          dateCancel = x.updated_on
        }
        if (x.status.includes('pre_reserved')) {
          type = 'SALE_PRERESERVATION'
          date = x.pre_reservation_date
          typeName = 'Pré-Réservation'
          color = 'has-background-pre_reserved'
          icon = 'fas fa-file-certificate'
        }
        let result = {
          date,
          type,
          dateCancel,
          canceledReason,
          typeName: typeName,
          color: color,
          icon: icon,
          account: x.account ? x.account.pk : x.account,
          accountName: x.account ? x.account.name : x.account,
          lot: x.lot.pk,
          lotName: x.lot.ref,
          program: x.program.pk,
          programName: x.program.name,
          advRef: x.ref,
          advPk: x.pk
        }
        if (x.user) {
          result.user = x.user.pk
          result.userName = `${x.user.last_name} ${x.user.first_name}`
        }
        const buyers = Array.isArray(x.buyers_data) ? x.buyers_data : []
        const fullName = b => `${b.last_name || ''} ${b.first_name || ''}`.trim()
        const me = buyers.find(b => b && b.pk === this.contactPk)
        if (me && me.substitution) {
          // ce contact est le substituant : la ligne prend la date de la substitution
          result.createdDate = result.date
          result.date = me.substitution.date
          result.replaces = (me.substitution.replaced || []).map(b => ({ pk: b.pk, name: fullName(b) }))
          return result
        }
        if (!me && buyers.length && !x.status.includes('canceled')) {
          // ce contact est lié à la résa mais n'est plus acquéreur : il a été substitué
          const substituant = buyers.find(b => b && b.substitution &&
            (b.substitution.replaced || []).some(r => r.pk === this.contactPk))
          return [result, {
            ...result,
            type: 'SALE_SUBSTITUTED',
            typeName: 'Substitution acquéreur',
            color: 'has-background-dark',
            icon: 'fal fa-user-friends',
            date: substituant ? substituant.substitution.date : x.updated_on,
            substitutedBy: (substituant ? [substituant] : buyers).map(b => ({ pk: b.pk, name: fullName(b) }))
          }]
        }
        return result
      }).reduce((all, item) => all.concat(item), [])
    },
    sortedHistory () {
      let items = [
        ...this.options,
        ...this.claims,
        ...this.rdvs,
        ...this.reservations,
        ...this.shareIntent,
        ...this.updateUserHistory
      ]
      return [...items.sort((a, b) => {
        return moment(b.date).format('x') - moment(a.date).format('x')
      }), ...this.history]
    },
    contactNotesFilter () {
      if (this.viewAllNotes) return this.contactNotes
      return this.contactNotes.filter((el, i) => {
        return i < this.notesCompactMode
      })
    }
    // isRemindListInFuture () {
    //   if (this.reminderForContact.length) {
    //     const now = moment()
    //     return this.reminderForContact.some(remind => moment(remind.date).isAfter(now))
    //   } else {
    //     return false
    //   }
    // }
  },
  watch: {
    sourceContactNotes (v) {
      this.updateSources({ notes: v })
    },
    'openCommentWysi' (v) {
      if (typeof v === 'number') {
        if (this.lastIndex === null) {
          this.lastIndex = v
        }
        if (this.lastCommentInit === null) {
          this.lastCommentInit = this.baseLotComment
        }
        if (v !== this.lastIndex) {
          // Verification du de la modif 'commentaire' entre 2 changement d'index wysig
          if (this.lastCommentInit !== this.sortedHistory[this.lastIndex].comment) {
            if (this.sortedHistory[this.lastIndex].comment === '') {
              const optionSave = this.sortedHistory[this.lastIndex]
              const commentSave = this.lastCommentInit
              this.openCommentWysi = null
              this.deleteComment(optionSave)
                .then((result) => {
                  if (result !== false) {
                    this.lastIndex = null
                    this.lastCommentInit = null
                  } else {
                    const option = this.contactOptions.find(x => x.pk === optionSave.pk)
                    if (!option) {
                      this.$toasted.global.danger('Option nous trouver dans la base de données')
                    } else {
                      option.comment = commentSave
                    }
                  }
                })
                .catch((error) => {
                  console.error(error)
                })
            } else {
              this.patchComment(this.sortedHistory[this.lastIndex])
            }
          }
          this.lastIndex = v
          this.lastCommentInit = this.baseLotComment
        }
      }
    }
  },
  created  () {
    this.getReminder()
  },
  methods: {
    async getReminder () {
      const result = await this.$api.get(this.$resources.REMINDER, { contact: this.contact.pk })
      this.reminderForContact = result.data.items
    },
    async deleteNote (note) {
      this.$emit('deleteNote', note)
      this.noteClose()
    },
    // openNote (note) {
    //   if ('rdv' in note && note.rdv) {
    //     let item = {
    //       message: note.message
    //     }
    //     this.openNoteQuickview({ item }, note.rdv)
    //   } else {
    //     this.openNoteQuickview({ item: Object.assign({}, note) })
    //   }
    // },
    toggleNotes () {
      this.viewAllNotes = !this.viewAllNotes
    },
    noteClose () {
      this.openWysi = null
    },
    noteSave (note) {
      if ('pk' in note && note.pk) {
        this.$emit('editNote', note)
      } else {
        this.$emit('createNote', note)
      }
      this.noteClose()
    },
    openWysiwyg (index, h) {
      this.openCommentWysi = null
      const option = this.contactOptions.find(x => x.pk === h.pk)
      if (this.openCommentWysi === null && this.isPromoteur) {
        this.openCommentWysi = index
        this.baseOptionComment = option.comment
        this.baseLotComment = option.comment
        this.dataCom = option.comment
      }
      if (h.pk !== this.showCom.pk) {
        this.toggleCom(h.pk)
      }
      this.$nextTick(() => {
        let wysiElem = document.getElementsByClassName('ql-editor ql-blank')[0]
        if (wysiElem) {
          wysiElem.setAttribute('contenteditable', 'true')
          wysiElem.focus()
        }
      })
    },
    async deleteComment (h, i) {
      const option = this.contactOptions.find(x => x.pk === h.pk)
      let value = await this.$swal({
        title: 'Suppression commentaire',
        text: 'Confirmer la suppression du commentaire',
        icon: 'warning',
        confirmButtonText: 'Supprimer',
        customClass: {
          confirmButton: 'is-danger'
        }
      })
      if (value && value.dismiss) return false
      else if (value.value) {
        option.comment = null
        option.updated_on = this.moment().format()
        this.patchComment(option)
      }
    },
    async patchComment (option) {
      this.loadComment = true
      let payload = {
        comment: option.comment,
        previous_sign_date: option.previous_sign_date,
        updated_on: this.moment().format()
      }
      try {
        await this.$store.dispatch('getcurrentOption', option.pk)
        await this.$store.dispatch('patchOption', payload)
        this.$toasted.global.success('Option mis à jour')
        this.loadComment = false
        this.openWysiOption = null
        // this.openCommentWysi = null
        this.baseOptionComment = option.comment
        this.baseLotComment = option.comment
        if (option.comment === null || option.comment === '') {
          this.showCom = {}
        }
      } catch (e) {
        console.log(e)
        this.loadComment = true
        this.$toasted.global.danger('Erreur lors de la mise à jour')
      }
    },
    onChangeCom (h, val) {
      const option = this.contactOptions.find(x => x.pk === h.pk)
      if (!option) {
        this.$toasted.global.danger('Option non trouvée dans la base de données')
      } else {
        option.comment = val
      }
    },
    onChangeModifDate (h) {
      const option = this.contactOptions.find(x => x.pk === h.pk)
      if (!option) {
        this.$toasted.global.danger('Option non trouvée dans la base de données')
      } else {
        option.updated_on = moment().format()
      }
    },
    updatePreviousDate (newDate, h) {
      const option = this.contactOptions.find(x => x.pk === h.pk)
      if (!option) {
        this.$toasted.global.danger('Option nous trouver dans la base de données')
      } else {
        option.previous_sign_date = newDate
        if (newDate !== this.lastDate || option.pk !== this.lastPk) {
          this.patchComment(option)
        }
        this.lastDate = newDate
        this.lastPk = option.pk
      }
    },
    saveCom (h) {
      const option = this.contactOptions.find(x => x.pk === h.pk)
      if (!option) {
        this.$toasted.global.danger('Option nous trouver dans la base de données')
      } else {
        option.comment = this.baseLotComment
        // this.lastCommentInit = option.comment
        if (!option.comment) {
          this.showCom = {}
        }
        if (this.dataCom !== null) {
          option.comment = this.dataCom
          this.dataCom = null
        }
      }
    },
    getCancelReasonLabel (reasonValue) {
      const cancelReasons = {
        DENIAL_FUNDING: 'Refus de financement',
        WITHDRAWAL: 'Rétractation dans le délai de 10 jours',
        JOIN_DEATH: 'Décès conjoint',
        DIVORCE: 'Divorce',
        TRANSFER: 'Mutation',
        NO_SALE: 'Non-revente',
        JOB_LOSS: 'Perte d\'emploi',
        OTHER: 'Autre',
        RESERVATION_EXPIRES: 'Caducité réservation',
        SUBSTITUTION: 'Substitution'
      }
      return cancelReasons[reasonValue] || 'Motif inconnu'
    },
    toggleCom (pk) {
      this.showCom = {}
      this.$set(this.showCom, pk, true)
    },
    async openReminderCreation () {
      let params = {
        noRedirection: true,
        type: 'onlyReminder',
        contact: this.contact
      }
      await this.openCalendarNewActionContact(params)
      await this.getReminder()
    },
    async updateReminder (remind) {
      let params = {
        noRedirection: true,
        source: remind,
        type: 'onlyReminder'
      }
      await this.openCalendarNewActionContact(params)
      await this.getReminder()
    },
    async deleteReminder (remind) {
      let r = await this.confirmDelete()
      if (r.value) {
        let eventPk = remind.pk
        let key = moment(remind.date).format('DD/MM/YYYY')
        try {
          await this.$api.delete(this.$resources.REMINDER, eventPk)
          this.$store.commit('removeCalendarEvent', { eventPk, key, type: 'reminders' })
          this.getReminder()
          this.$toasted.global.success('Le rappel à été supprimé.')
        } catch (err) {
          console.log(err)
          this.handleError(err)
        }
      }
    },
    confirmDelete () {
      return this.$swal({
        title: 'Suppression rappel',
        text: 'Le rappel ne sera plus consultable.',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      })
    },
    openCalendarNewActionContact (params) {
      return new Promise((resolve) => {
        this.$store.commit('setQuickview', { mode: 'NEW_CALENDAR_ACTION', params, resolve })
      })
    },
    isRemindInFuture (date) {
      const dateFortest = moment(date).add(2, 'hours').toDate()
      return moment().isBefore(dateFortest)
    }
  }
}
</script>
<style>
.font{
  font-size: 10px;
}

.is-flex-npwrap {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: hidden;
}

.router-link-item {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  margin-right: 10px;
}

.update-hover:hover {
  background-color: #80BB73;
  color: white;
  transition: background-color 0.4s ease-in-out;
}

.delete-hover:hover {
  background-color: #DB534D;
  color: white;
  transition: background-color 0.4s ease-in-out;
}
</style>
